import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { UpdateCoupling, UpdateCouplingName, UpdateCouplingRank } from '../../../UpdateData/UpdateCommunications';
import DialogCouplingConnectionComponent from '../DialogConnectionComponents/DialogCouplingConnectionComponent';
import { loadingCouplingDataComponent, loadingRankComponentDataComponent } from '../../../LoadingData/LoadingDataComponents';
import DialogCouplingFotoEditing from '../DialogFoto/DialogCouplingFotoEditing';
import { COUPLING, COUPLING_FLAG } from '../../../Constants/ConstantsOptics';
import ModalDeleteComponentSpecifically from '../../../Modal/ModalDeleteComponentSpecifically';
import { UpdateCouplingEtherComponents, UpdateCouplingKtvComponents, UpdateCouplingPonComponents, UpdateStatusComponents } from '../../../UpdateData/UpdateStatusComponent';

const CouplingCantonEditingDialog = ({ open, onClose, onClose2, content, user, cantonCouplingRefresh, groupedCoordinatesWithColorTypeAndWidth,
  wellData,fobLocationData,couplingLocationData,ponBoxLocationData,pillarData, setIsComponentСhangeCoorCoupling}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [openModalConnection, setOpenModalConnection] = useState(false);
  const [couplingData, setCouplingData] = useState([]);
  const [couplingId, setCouplingId] = useState("");
  const [rankComponentData, setRankComponentData] = useState([]);
  const [couplingRankId, setCouplingRankId] = useState("");
  const [openModalFoto, setOpenModalFoto] = useState(false);
  const [openModalConnectionDelete, setOpenModalConnectionDelete] = useState(false);
  const [statusPon, setStatusPon] = useState(false); 
  const [statusKtv, setStatusKtv] = useState(false); 
  const [statusEther, setStatusEther] = useState(false); 

   useEffect(() => {
      setStatusPon(content.pon === 1);
      setStatusKtv(content.ktv === 1);
      setStatusEther(content.ether === 1);
    }, [content.activity, content.pon, content.ktv, content.ether]);
  
    const handleСhangeCoor= (event) => {
      handleCloseDialogs();
      setIsComponentСhangeCoorCoupling(true);
    }

  const openModalConnectionComponentsDelete = () => {
    setOpenModalConnectionDelete(true);
  }; 

  const openModalFotoFile = () => {
    setOpenModalFoto(true);
  }; 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [couplingData, rankComponentData] = await Promise.all([
          loadingCouplingDataComponent(),
          loadingRankComponentDataComponent(),
        ]);
        setCouplingData(couplingData);
        setRankComponentData(rankComponentData);
      } catch (error) {
        // Обработка ошибок
        // console.error("Error in fetchData:", error);
      }
    };
  
    fetchData();
  }, []);

   const deleteCoupling = () => {
        UpdateStatusComponents(COUPLING, content.id, showSnackbar, user, cantonCouplingRefresh, handleCloseDialogs );
   };   

  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

  const openModalConnectionComponents = () => {
    setOpenModalConnection(true);
  }; 

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };
 
  const updateCoupling = () => {
    if (statusChange) {
      UpdateCoupling(content.id, textComment, showSnackbar,content.authorId, cantonCouplingRefresh);
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };

  const handleChangeCouplingSelect = (event) => {
    const selectedCoupling = event.target.value;
    if (selectedCoupling === "") {
      setCouplingId("");
    } else {
      const selectedCoupling2 = couplingData.find(coupling => 
        `${coupling.id}` === selectedCoupling
      );
      if (selectedCoupling2) {
        setCouplingId(selectedCoupling2.id);
      }
    }
  };

  const updateCouplingName = () => {
  
    if (couplingId === "") {
      showSnackbar('Нет нужды в записи, кабель без изменений!', 'snackbarOk');
    } else {
      UpdateCouplingName(content.id, couplingId, showSnackbar,content.authorId, cantonCouplingRefresh );
    } 
  };

  const handleChangeCouplingRankSelect = (event) => {
    const selectedCouplingRank = event.target.value;
    if (selectedCouplingRank === "") {
      setCouplingRankId("");
    } else {
      const selectedCouplingRank2 = rankComponentData.find(couplingRank => 
        `${couplingRank.id}` === selectedCouplingRank
      );
      if (selectedCouplingRank2) {
        setCouplingRankId(selectedCouplingRank2.id);
      }
    }
  };

  const updateCouplingRank = () => {
  
    if (couplingRankId === "") {
      showSnackbar('Нет нужды в записи, ранг без изменений!', 'snackbarOk');
    } else {
      UpdateCouplingRank(content.id, couplingRankId, showSnackbar,content.authorId, cantonCouplingRefresh );
    } 
  };


   const handlePonCheckboxChange = () => {
      setStatusPon(!statusPon);   
      if(!statusPon){
        UpdateCouplingPonComponents(content.id, 1, showSnackbar, cantonCouplingRefresh, content.authorId);
      }else{
        UpdateCouplingPonComponents(content.id, 0, showSnackbar, cantonCouplingRefresh, content.authorId)
      }
      
    };
  
    const handleKtvCheckboxChange = () => {
      setStatusKtv(!statusKtv);   
      if(!statusKtv){
        UpdateCouplingKtvComponents(content.id, 1, showSnackbar, cantonCouplingRefresh, content.authorId);
      }else{
        UpdateCouplingKtvComponents(content.id, 0, showSnackbar, cantonCouplingRefresh, content.authorId)
      } 
    };
  
    const handleEtherCheckboxChange = () => {
      setStatusEther(!statusEther);   
      if(!statusEther){
        UpdateCouplingEtherComponents(content.id, 1, showSnackbar, cantonCouplingRefresh, content.authorId);
      }else{
        UpdateCouplingEtherComponents(content.id, 0, showSnackbar, cantonCouplingRefresh, content.authorId)
      }
    };

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      {content.rankComponentId === 1 || content.rankComponentId === 2 ? (
           <img src='./сoupling.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./coupling_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Редактирование муфты</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Город: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #3d3d3d'}}>{content.city}</span> </label>
      <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !content.canton ? '#de858e' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {content.canton
                    ? content.region && content.area
                      ? `${content.canton} ${content.region} ${content.area}`
                      : content.canton
                    : 'нет'}
                </span>
              </label>  
              <hr className='horizontalLineDialog'/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Муфта: </label>

        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeCouplingSelect(event);
          }} >
          <option value="">{content.couplingName}</option>
          {couplingData.map(coupling => (
            <option key={coupling.id} value={coupling.id}>{coupling.name}</option>
          ))}
        </select>
        <button onClick={updateCouplingName} class='buttonIsSaveDialog2'>Сохранить</button>

        <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      
        <label style={{ color: '#292929', fontWeight: 'bold'}}>Мax ранг линка: </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeCouplingRankSelect(event);
          }} >
          <option value="">{content.rankComponentName}</option>
          {rankComponentData.map(rank => (
            <option key={rank.id} value={rank.id}>{rank.name}</option>
          ))}
        </select>
        <button onClick={updateCouplingRank} class='buttonIsSaveDialog2'>Сохранить</button>
        <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 


        <label style={{ color: '#292929', fontWeight: 'bold'}}>Признак:</label>

        <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>PON:</label>
            <input
              type="checkbox"
              checked={statusPon}
              onChange={handlePonCheckboxChange}
              style={{ marginLeft: '10px' }}
            />      

          <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>KTV:</label>
            <input
              type="checkbox"
              checked={statusKtv}
              onChange={handleKtvCheckboxChange}
              style={{ marginLeft: '10px' }}
            />      

          <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>Ethernet:</label>
            <input
              type="checkbox"
              checked={statusEther}
              onChange={handleEtherCheckboxChange}
              style={{ marginLeft: '10px' }}
            />      

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />

      <br/>
         <button onClick={updateCoupling} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>
      <hr className='horizontalLineDialog'/>
      <button  class='buttonIsCoupFobDialog' onClick={openModalConnectionComponents}> Закрепить муфту</button>

      <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
      <button  class='buttonIsEditDialog' onClick={handleСhangeCoor}> Редактировать на карте</button>
      <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />

      <button class='buttonIsEditDialog' onClick={openModalConnectionComponentsDelete}>Удаление связей</button>
      <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />

      <button  class='buttonIsEditDialog' onClick={openModalFotoFile}> Редактирование файлов</button>
      <hr className='horizontalLineDialog'/>

      <button 
          className="buttonIsDeleteModal" 
          onClick={deleteCoupling} 
          style={{ fontSize: "14px", width: "60px", padding: "2px" ,textShadow: '2px 2px 4px #3d3d3d'}}
        >
          Удалить
        </button>

        <span 
          style={{
            marginLeft: "5px",
            fontSize: "12px",
            color: "#bebebe",
            textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
            
          }}
        >
        Восстановление доступно в течение 24 часов
      </span>
 
      <hr className='horizontalLineDialog'/>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
          Закрыть
        </Button>
      </DialogActions>

       <ModalDeleteComponentSpecifically
          open={openModalConnectionDelete}
          onClose={() => setOpenModalConnectionDelete(false)}
          id={content.id}
          type={COUPLING}
          flag={COUPLING_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

      <DialogCouplingConnectionComponent
          id={content.id}
          open={openModalConnection}
          onClose={() => setOpenModalConnection(false)}
          user={user}
      />

       {/* Modal Foto*/}
       <DialogCouplingFotoEditing
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}
          user={content.authorId}     
      />   
    </Dialog>
  );
}

export default CouplingCantonEditingDialog;